{
	"condition": {
		"9": "Kuin uusi",
		"8": "Erinomainen",
		"7": "Hyvä",
		"6": "Kohtalainen",
		"5": "Kulunut",
		"1-3": "Beat"
	},
	"discClass": {
		"putter": "Putteri",
		"midrange": "Midrange",
		"fairway-driver": "Fairway-kiekko",
		"distance-driver": "Distanse-kiekko"
	},
	"shipsTo": {
		"pickup-only": "Vain nouto",
		"domestic": "Kotimaahan",
		"international": "Ulkomaille"
	},
	"backToListings": "Takaisin ilmoituksiin",
	"flightNumbers": {
		"label": "Lentonumerot",
		"estimated": "Arvioidut lennot",
		"official": "Viralliset lentonumerot",
		"speed": "Nopeus",
		"glide": "Liito",
		"turn": "Vakaus",
		"fade": "Feidi"
	},
	"sections": {
		"description": "Kuvaus",
		"photos": "Kuvat",
		"location": "Sijainti",
		"seller": "Myyjä",
		"viewProfile": "Näytä profiili →"
	},
	"actions": {
		"edit": "Muokkaa",
		"markAsSold": "Merkitse myydyksi",
		"deactivate": "Poista käytöstä",
		"reactivate": "Aktivoi uudelleen",
		"save": "Tallenna",
		"saved": "Tallennettu",
		"saveToWatchlist": "Lisää seurantaan",
		"removeFromWatchlist": "Poista seurannasta"
	},
	"price": {
		"negotiable": "Neuvoteltavissa",
		"inactive": "Ei aktiivinen"
	},
	"reviews_one": "arvostelu",
	"reviews_other": "arvostelua",
	"images": {
		"noImage": "Ei kuvaa",
		"topView": "Ylänäkymä",
		"bottomView": "Alanäkymä",
		"sideView": "Sivunäkymä",
		"extra": "Lisäkuva"
	}
}
